// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Vue-Toastification__close-button.show-on-hover{opacity:1!important;color:#000}.b-toast{top:55px}", ""]);
// Exports
module.exports = exports;
